
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > types <
import type { MAnalyticGlobalSearchItem } from '@/modern/modules/m-analytics-module/services/types/analytics'

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<MAnalyticGlobalSearchItem>,
            required: true
        }
    }
})
